import { createContext, useContext } from 'react'
import { type HubspotWorkflowsListStore } from 'pages/hubspotWorkflows/ui/hubspotWorkflowsList/store/HubspotWorkflowsListStore'

export const HubspotWorkflowsListContext = createContext<HubspotWorkflowsListStore | null>(null)

export const useHubspotWorkflowsListContext = () => {
  const context = useContext(HubspotWorkflowsListContext)

  if (context === null)
    throw new Error(
      'You have forgotten to wrap your root component with HubspotWorkflowsListContext'
    )

  return context
}
